"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import {styled} from "@mui/material/styles";

// TODO:
// As this component doesn't have own styles we should use Tabs direct from MUI
// 1) Check and remove: import { Tabs } from "paul-core-package"; in other packages.
// 2) Use Tabs direct from MUI in each package: import { Tabs } from '@mui/material';
// 3) Remove Tabs component here in paul-core-package.
const Tabs = props => {
  // const StyledTabs = styled(MuiTabs)({
  //     minHeight: 36.5,
  //     height: 36.5,
  //     border: 'none',
  //     '.MuiTabs-centered': {
  //         marginBottom: 3.5,
  //     },
  //     '.MuiTabs-indicator': {
  //         backgroundColor: '#0000FF',
  //     },
  //     '.Mui-selected': {
  //         opacity: 1,
  //     }
  // })
  // return <StyledTabs {...props} />
  return /*#__PURE__*/_react.default.createElement(_material.Tabs, props);
};
var _default = exports.default = Tabs;